import React from "react";
import Fade from "react-reveal/Fade";
import "./ExperienceCard.scss";

interface ExperienceCardProps {
  year: string;
  role: string;
  company: string;
  description: string;
  img: string;
}

const ExperienceCard = (props: ExperienceCardProps) => {
  const { year, role, company, description, img } = props;
  return (
    <Fade bottom>
      <div className="timeline-item">
        <div className="row align-items-center">
          <div className="col-lg-3 col-md-4 col-sm-12" id="logo">
            <img loading="lazy" className="img-fluid" src={img} alt="logo" />
          </div>
          <div className="col-lg-9 col-md-8 col-sm-12" id="info">
            <span className="date"> {year}</span>
            <h2 className="title">{role}</h2>
            <h3 className="sub">{company}</h3>
            <p className="description">{description}</p>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default ExperienceCard;
